import { useCallback, useEffect, useRef } from 'react';
import { mergeTypeDefs } from '@graphql-tools/merge';
import { afterEffectsSchema } from '../aftereffects';
import { initializeExecutableSchema } from '../executableSchema';
import { premiereSchema, type Resolvers } from '../premierepro';
import { sharedSchema } from '../shared';
import { mockEventHandler } from './mockEventHandler';
import {
  mockResolver,
  subscribeToSubscriptionMocks,
  unsubscribeFromSubscriptionMocks,
} from './mockResolver';

const typeDefs = mergeTypeDefs([
  sharedSchema,
  premiereSchema,
  afterEffectsSchema,
]);

const MockResolver = () => {
  const windowRef = useRef<Window>(window);
  const hasMockedUXPHost = useRef(false);

  const mockUXPHost = useCallback(() => {
    subscribeToSubscriptionMocks();
    initializeExecutableSchema({
      hostApp: 'premierepro',
      resolvers: mockResolver as Resolvers,
      typeDefs,
    });
    const mockUxpHost = {
      postMessage: (message: unknown, targetOrigin?: string) => {
        const messageEvent = new MessageEvent('message', {
          data: message,
          origin: targetOrigin || '*',
        });

        mockEventHandler(messageEvent, windowRef);
      },
    };
    window.uxpHost = mockUxpHost;
  }, []);

  useEffect(() => {
    if (!hasMockedUXPHost.current) {
      mockUXPHost();
      hasMockedUXPHost.current = true;
    }
    subscribeToSubscriptionMocks();
    return () => {
      unsubscribeFromSubscriptionMocks();
    };
  }, [mockUXPHost]);

  return null;
};

export const SetupMockResolver = () => {
  if (
    typeof window !== 'undefined' &&
    // eslint-disable-next-line no-storage/no-browser-storage
    localStorage.getItem('mock-premiere-resolver') === 'true'
  ) {
    return <MockResolver />;
  }
  return null;
};
